import addCLPLabelInfoBar from '../utils/addCLPLabelInfoBar';
import addEncryptionInfobarFromIRMData from '../utils/addEncryptionInfobarFromIRMData';
import { lazyLoadItemCLPInfo } from 'owa-mail-clp';
import { isFeatureEnabled } from 'owa-feature-flags';
import updateCLPViewState from '../actions/updateCLPViewState';
import { getStore } from 'owa-mail-compose-store';
import Item from 'owa-service/lib/contract/Item';

export default function loadItemLabelBeforeCompose(
    existingLabelString: string,
    referenceItem: Item,
    composeId: string
) {
    if (isFeatureEnabled('cmp-clp') && !existingLabelString && referenceItem) {
        lazyLoadItemCLPInfo.importAndExecute(referenceItem.ItemId.Id).then(itemCLPInfo => {
            // it's ok if the user send before then gets triggered,
            // serverside will handle the labeling.
            const viewState = getStore().viewStates.get(composeId);

            // If user discard the message before premise is resolve this view state is null.
            if (!viewState) {
                return;
            }

            const { clpViewState } = viewState;

            updateCLPViewState(viewState, itemCLPInfo);

            const { selectedCLPLabel } = clpViewState;

            if (!(selectedCLPLabel && selectedCLPLabel.isEncryptingLabel)) {
                addEncryptionInfobarFromIRMData(viewState);
            }
            addCLPLabelInfoBar(viewState);
        });
    }
}
